/**
 * v2 (26/10/2026) — a copied list → its twin in this country (the same name without the country
 * prefix; the nearest names first in the list), another of this country's lists, or Leave out —
 * its drop pins, "my order" place and own settings stay behind (user: "same for the list").
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useMemo } from 'react';
import type { GroupCopyListRow } from '@trafficpulse/shared';

import { SearchableSelect, type SearchableSelectOption } from '@/components/ui';
import { middleTruncate } from '@/features/drop-generator/components/campaign/campaign-scope';

import { matchBadge } from '../MatchBadge';
import { PickRow, usedByLine } from '../PickRow';
import { LEAVE_OUT } from './GatewayPick';

interface Props {
  row: GroupCopyListRow;
  /** Every list of this country, built once for every row. */
  options: SearchableSelectOption<string>[];
  answered: boolean;
  onPick: (target: number | null) => void;
  /** In a fold: one line (27/10/2026). */
  compact?: boolean;
}

export const ListPick: FC<Props> = ({ row, options, answered, onPick, compact }) => {
  const ordered = useMemo(() => {
    const near = new Set(row.candidates.map((c) => String(c.wiserId)));
    const first = row.candidates.flatMap((c) => options.filter((o) => o.value === String(c.wiserId)));
    return [...first, ...options.filter((o) => !near.has(o.value)), { value: LEAVE_OUT, label: 'Leave out' }];
  }, [row.candidates, options]);
  const value = row.target !== null ? String(row.target) : answered || row.how !== 'none' ? LEAVE_OUT : '';
  return (
    <PickRow
      compact={compact}
      name={row.sourceName}
      source={<span className="truncate font-mono text-[12px]" title={row.sourceName}>{middleTruncate(row.sourceName, 44)}</span>}
      select={<SearchableSelect options={ordered} value={value} onChange={(v) => onPick(v === LEAVE_OUT ? null : Number(v))} placeholder="Pick a list…" searchPlaceholder="Search a list…" className="h-8" />}
      badge={matchBadge(row.how, row.target !== null, answered)}
      meta={usedByLine(row.usedBy)}
      onConfirm={row.target !== null ? () => onPick(row.target) : undefined}
    />
  );
};
